// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gV0lO","colMin":"styles_colMin__3c0fl"};